// LoginPage.jsx
import { useState } from "react";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const MAIN_ADMIN_EMAIL = "notloser.08@gmail.com";

export default function LoginPage({ onLogin }) {
  const [loginError, setLoginError] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);

  const handleLogin = async () => {
    if (loggingIn) return;

    setLoginError("");
    setLoggingIn(true);

    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      // ผู้ใช้ใหม่ต้องรอแอดมินอนุมัติและผูกชื่อทีมก่อนใช้งานจริง
      // ยกเว้นบัญชีแอดมินหลัก เพื่อไม่ล็อกตัวเองออกจากระบบในกรณีเริ่มโปรเจกต์ใหม่
      const isMainAdmin = user.email === MAIN_ADMIN_EMAIL;
      await setDoc(userRef, {
        name: user.displayName || "",
        email: user.email || "",
        role: isMainAdmin ? "admin" : "pending",
        teamName: isMainAdmin ? "ยย" : "",
        realName: "",
        createdAt: new Date(),
      });
    } else {
      // ผู้ใช้เดิม: อัปเดตเฉพาะข้อมูลโปรไฟล์ ห้ามแตะ role/teamName เดิมเด็ดขาด
      await setDoc(
        userRef,
        {
          name: user.displayName || userSnap.data()?.name || "",
          email: user.email || userSnap.data()?.email || "",
          lastLoginAt: new Date(),
        },
        { merge: true }
      );
    }

      onLogin(user);
    } catch (error) {
      console.error("Google sign-in failed:", error);

      if (error?.code === "auth/popup-closed-by-user") {
        setLoginError("ยกเลิกการเข้าสู่ระบบแล้ว กรุณากดเข้าสู่ระบบใหม่อีกครั้ง");
      } else if (error?.code === "auth/popup-blocked") {
        setLoginError("เบราว์เซอร์บล็อกหน้าต่างเข้าสู่ระบบ กรุณาอนุญาต Pop-up แล้วลองใหม่");
      } else if (error?.code === "auth/unauthorized-domain") {
        setLoginError("โดเมนเว็บยังไม่ได้รับอนุญาตใน Firebase Authentication กรุณาแจ้งแอดมิน");
      } else {
        setLoginError("เข้าสู่ระบบไม่สำเร็จ กรุณาปิดหน้านี้แล้วลองใหม่อีกครั้ง");
      }
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>🎫 ค่ากดทีมยยมือทองกดบัตร</h1>
        <p style={styles.subtitle}>กรุณาเข้าสู่ระบบด้วยบัญชี Google เพื่อใช้งานระบบ</p>
        <button
          onClick={handleLogin}
          style={{ ...styles.button, opacity: loggingIn ? 0.65 : 1 }}
          disabled={loggingIn}
        >
          {loggingIn ? "กำลังเข้าสู่ระบบ..." : "🔐 เข้าสู่ระบบด้วย Google"}
        </button>
        {loginError && <p style={styles.error}>{loginError}</p>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(to right, #fce7f3, #fff7ed)",
    fontFamily: "'Noto Sans Thai', sans-serif",
    padding: 20,
  },
  card: {
    background: "#fff",
    padding: "40px 24px",
    borderRadius: 20,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: 400,
    width: "100%",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#f43f5e",
    marginBottom: 10,
  },
  subtitle: {
    fontSize: "1rem",
    color: "#6b7280",
    marginBottom: 20,
  },
  error: {
    marginTop: 14,
    marginBottom: 0,
    color: "#be123c",
    fontSize: "0.9rem",
    lineHeight: 1.5,
  },
  button: {
    background: "linear-gradient(to right, #fb7185, #f97316)",
    color: "white",
    padding: "12px 20px",
    fontSize: "1rem",
    fontWeight: "bold",
    border: "none",
    borderRadius: 10,
    cursor: "pointer",
    transition: "transform 0.2s ease",
  },
};
